export var SIMPHONY_TENDER_SERVICE_TOTAL = 'serviceTotal';
export var SimphonyEmployeeLookupStatus;
(function (SimphonyEmployeeLookupStatus) {
    SimphonyEmployeeLookupStatus["FOUND"] = "FOUND";
    SimphonyEmployeeLookupStatus["NOT_FOUND"] = "NOT_FOUND";
    SimphonyEmployeeLookupStatus["ERROR"] = "ERROR";
})(SimphonyEmployeeLookupStatus || (SimphonyEmployeeLookupStatus = {}));
